export const getCurrentSlice = (reducerName) => {
  switch (reducerName) {
    case 'kioskReducer':
      return require('store/kiosk/kioskSlice');
    case 'newsSearchResourceReducer':
      return require('store/searchResource/newsSearchResourceSlice');
    case 'instagramSearchResourceReducer':
      return require('store/searchResource/instagramSearchResourceSlice');
    case 'twitterSearchResourceReducer':
      return require('store/searchResource/twitterSearchResourceSlice');
    case 'virastySearchResourceReducer':
      return require('store/searchResource/virastySearchResourceSlice');
    case 'telegramSearchResourceReducer':
      return require('store/searchResource/telegramSearchResourceSlice');
    case 'newspaperSearchResourceReducer':
      return require('store/searchResource/newspaperSearchResourceSlice');
    case 'nativePlatformsSearchResourceReducer':
      return require('store/searchResource/nativePlatformsSearchResourceSlice');
    case 'multiPlatformContentReducer':
      return require('store/content/multiPlatformContentSlice');
    case 'newsContentReducer':
      return require('store/content/newsContentSlice');
    case 'copyNewsContentReducer':
      return require('store/content/copyNewsContentSlice');
    case 'instagramContentReducer':
      return require('store/content/instagramContentSlice');
    case 'instagramCommentByCommentContentReducer':
      return require('store/content/instagramCommentByCommentContentSlice');
    case 'instagramCommentByPostContentReducer':
      return require('store/content/instagramCommentByPostContentSlice');
    case 'twitterContentReducer':
      return require('store/content/twitterContentSlice');
    case 'virastyContentReducer':
      return require('store/content/virastyContentSlice');
    case 'telegramContentReducer':
      return require('store/content/telegramContentSlice');
    case 'linkedinContentReducer':
      return require('store/content/linkedinContentSlice');
    case 'newspaperContentReducer':
      return require('store/content/newspaperContentSlice');
    case 'nativePlatformsContentReducer':
      return require('store/content/nativePlatformsContentSlice');
    case 'settingsReducer':
      return require('store/settings/settingsSlice');
    case 'resourceCategoryReducer':
      return require('store/resourceCategory/resourceCategorySlice');
    case 'blackListReducer':
      return require('store/blackList/blackListSlice');
    case 'vipResourcesReducer':
      return require('store/vipResources/vipResourcesSlice');
    case 'alarmReducer':
      return require('store/alarm/alarmSlice');
    case 'storyReducer':
      return require('store/story/storySlice');
    case 'dashboardReducer':
      return require('store/dashboard/dashboard.slice');
    case 'autoBulletinReducer':
      return require('store/autoBulletin/autoBulletin.slice');
    default:
      return {};
  }
};
